import { Action, Selector, State, StateContext } from "@ngxs/store";
import { LineCalendarData } from "../../models/CalendarData";
import {
  AddBidListData,
  RemoveBidListData,
} from "../actions/bidListData.action";

export class BidListDataStateModel {
  bidListData: LineCalendarData[];
}

@State({
  name: "bidListData",
  defaults: {
    bidListData: undefined,
  },
})
export class BidListDataState {
  @Selector()
  static getBidListData(state: BidListDataStateModel) {
    return state.bidListData;
  }

  @Action(AddBidListData)
  add(
    { patchState }: StateContext<BidListDataStateModel>,
    { payload }: AddBidListData
  ) {
    patchState({ bidListData: payload });
  }

  @Action(RemoveBidListData)
  remove({ patchState }: StateContext<BidListDataStateModel>) {
    patchState({ bidListData: undefined });
  }
}
